
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {


  constructor(private router: Router, private gtmService: GoogleTagManagerService) { }

  isMenuOpen: boolean[] = [];
  openMobileMenu = false;
  transactionId = 332950684;


  menu: any[] = [
    {
      title: "Para sua empresa",
      showCategories: false,
      categories: [
        {
          name: "Maquininhas",
          showItems: false,
          linkExternal: false,
          items: [
            { label: "azulzinha pro", link: "/maquininhas/pro" },
            { label: "azulzinha aproxima", link: "/azulzinha-aproxima" },
            { label: "azulzinha smart", link: "/azulzinhasmart" },
            { label: "azulzinha TEF", link: "/maquininhas/tef" },
            { label: "Clover", link: "/clover" },
            { label: "Todos os modelos", link: "/maquininhas", highlight: true }
          ]
        },
        {
          name: "Serviços",
          showItems: false,
          linkExternal: false,
          items: [
            { label: "Antecipação de Vendas", link: "/antecipacao-de-vendas" },
            { label: "Bandeiras e Vouchers", link: "/bandeiras-vouchers" },
            { label: "Crediário", link: "/crediario-azulzinha" },
            { label: "Pagamento Parcial", link: "/pagamento-parcial" },
            { label: "Pix", link: "/pix-azulzinha" },
            { label: "Recarga", link: "/recarga-de-celulares" }
          ]
        },
        {
          name: "Vendas Online",
          showItems: false,
          linkExternal: false,
          items: [

            { label: "Link de Pagamento", link: "/link-pagamento" },
            { label: "Pagamentos por WhatsApp", link: "/pagamentos-whatsapp" },
            { label: "Todas as soluções", link: "/vendas-online", highlight: true }

          ]
        },
        {
          name: "Gestão",
          showItems: false,
          linkExternal: false,
          items: [
            { label: "App da azulzinha", link: "/app" },
            { label: "Portal da azulzinha", link: "/portal" },
            { label: "Todas as soluções", link: "/gestao", highlight: true }

          ]
        },
        {
          name: "Para sua Lotérica",
          showItems: false,
          linkExternal: false,
          orange: true,
          items: [
            { label: "Serviço de Conveniência", link: "lotericas" }

          ]
        },
        {
          name: "Para sua MEI",
          showItems: false,
          linkExternal: false,
          orange: true,
          items: [
            { label: "App CAIXA Tem", link: "/azulzinha-caixa-tem" }

          ]
        },
      ]
    },
    {
      title: "Para você",
      showCategories: false,
      categories: [
        {
          name: "Serviços",
          showItems: true,
          linkExternal: true,
          items: [
            { label: "azulzinha pay", link: "https://www.azulzinhapay.com.br/" },
          ]
        },
        {
          name: "Lotéricas",
          showItems: true,
          linkExternal: false,
          items: [
            { label: "Serviço de Conveniência", link: "/cliente-loterica" }
          ]
        }
      ]
    }
  ];

  ngOnInit(): void {
    window.scrollTo(0, 0)
    this.onNavigation()
    this.isMenuOpen = this.menu.map(() => false);

  }

  onNavigation(label: string = '') {

    const normalize = (str: string) => str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-')
      .toLowerCase();

    const tag = `clicou-em-${normalize(label)}`;

    let gtmtag = {};
    gtmtag = {
      event: tag,
      name: label,
      transactionId: this.transactionId
    };
    console.log(gtmtag);
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
          transactionId: this.transactionId
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }

  toggleCategories(selectedItem: any): void {
    this.menu.forEach(item => {
      item.showCategories = (item === selectedItem) ? !item.showCategories : false;
    });
  }

  toggleItems(menuItem: any, selectedCategory: any): void {
    menuItem.categories.forEach((category: any) => {
      category.showItems = (category === selectedCategory) ? !category.showItems : false;
    });
  }

  toggleMobileMenu() {

    this.menu.forEach(menuItem => {
      menuItem.showCategories = false;
      menuItem.categories.forEach((category: any) => {
        category.showItems = false;
      });
    });
    this.openMobileMenu = !this.openMobileMenu;

  }
  handleCloseDialog(index: number) {
    this.isMenuOpen[index] = false;
  }

}

